import React, { useEffect } from "react";
import Checkbox, { CheckBoxSize } from "../../../common/ui/Checkbox";
import { ISentMessageModel } from "../../../../core/viewModels/message/SentMessageModel";
import { getFormattedSentDate } from "../../../../helper/DateHelperFunctions";
import { DeliveryType, FolderType, MessageType } from "../../../../core/common/enums";
import { convertHtmlStringToText } from "../../../../helper/HelperFunctions";
import { ChevronDownIcon, ChevronRightIcon, ForwardIcon, SlantedPaperClipIcon } from "../../../svg/IconCollection";
import { ColorConstants } from "../../../../assets/custom/colors";
import { ThreadStyleClassNames } from "../../../../helper/Constants";

interface ISentMessageListItemProps {
    message: ISentMessageModel;
    selectedMessageId: number;
    index: number;
    isChecked: boolean;
    onSelected: (message: ISentMessageModel, e: any) => void;
    onClick: (message: ISentMessageModel, e: any) => void;
    isThreadMessage?: boolean;
    selectedSentMessage?:any;
    collapseAllThreads?: boolean;
    selectedMessageOriginFolder: number;
}
const SentMessageListItem: React.FC<ISentMessageListItemProps> = props => {
    const [isExpanded, setIsExpanded] = React.useState(false);

    useEffect(() => {
        setIsExpanded(false);
    }, [props.collapseAllThreads]);

    const handleCheckboxOnClick = () => {
        return;
    };
    const isThreadMessageSelected =
        `${props.selectedMessageId}_${props.selectedMessageOriginFolder}` ===
        `${props.message.sentMessageId}_${props.message.folderId}`;
    const threadItemStyle = isThreadMessageSelected ? ThreadStyleClassNames.THREAD_TITLE : "";
    const threadMessageStyle = isThreadMessageSelected ? ThreadStyleClassNames.THREAD_MESSAGE : "";
    const IconColor = isThreadMessageSelected ? ColorConstants.white_90 : ColorConstants.brand_pimary_blue_1;

    const getRecipientList = (value: string) => {
        const cell = (value && value.split(", ")) || [];
        return cell.length > 1 ? (
            <div className="pointer padding-right-20-px with-badge">
                <span className="ellipsis">{cell[0].length > 45 ? cell[0].substring(0, 30) + "..." : cell[0]}</span>
                <span className={`margin-left-5-px message-item-datetime ${threadMessageStyle}`} style={{ fontWeight: "normal" }}>
                    +{cell.length - 1}{" "}
                </span>
            </div>
        ) : (
            <span title={cell[0]}>{cell[0] || "-"}</span>
        );
    };
    const handleCheckboxOnChange = (e: any) => {
        props.onSelected(props.message, e);
    };

    const handleExpandThreads = () => {
        setIsExpanded(!isExpanded);
    };
    return (
        <div
            className={`card message-item 
            ${isThreadMessageSelected && "message-item-selected"} 
            ${props?.isThreadMessage && "thread-message-item"}
            ${props?.message?.threadMessages?.length ? "thread-message-item" : "simple-message-item"}
            `}
            key={props.index}
            style={{ marginBottom: !props?.isThreadMessage ? "12px" : "2px" }}
        >
            <div
                className={`card-body message-item-body 
                ${props.message?.threadMessages?.length ? " thread-child-message-item" : "parent-message-item"}`}
            >
                {props.message?.threadMessages && props.message?.threadMessages?.length > 0 && (
                    <div onClick={handleExpandThreads}>
                        {isExpanded ? <ChevronDownIcon color="#212529" /> : <ChevronRightIcon color="#212529" />}
                    </div>
                )}
                <div className="message-item-checkbox">
                    <Checkbox
                        id={`chkMessage_${props.message.sentMessageId}_${MessageType.SENT}_${props.message.folderId}`}
                        text=""
                        size={CheckBoxSize.sm}
                        checked={props.isChecked}
                        onChange={handleCheckboxOnChange}
                        onClick={handleCheckboxOnClick}
                        key={`${props.message.sentMessageId}_${props.message.folderId}`}
                    />
                </div>
                <div className="message-item-group" onClick={e => props.onClick(props.message, e)}>
                    <div className="row">
                        <div className="col-9">
                            {props.message.folderId !== FolderType.SENT ? (
                                <span
                                    className={`message-item-title text-ellipsis ellipsis ${threadItemStyle}`}
                                >{`${props.message.senderFirstName} ${props.message.senderLastName}`}</span>
                            ) : (
                                <span className={`message-item-title text-ellipsis ellipsis ${threadItemStyle}`}>
                                    {getRecipientList(props.message.recipientList)}
                                </span>
                            )}
                        </div>
                        <div className="col-3 text-end">
                            <span className={`message-item-datetime ${threadMessageStyle}`}>
                                {getFormattedSentDate(props.message.sentDate)}
                            </span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xs-12">
                            {!props.isThreadMessage && (
                                <div
                                    className="message-item-subject ellipsis"
                                    style={{ maxWidth: "250px", maxHeight: "20px" }}
                                >
                                    {props.message.subject || <span>&nbsp;</span>}
                                </div>
                            )}
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <div
                                    className={`message-item-messagebody ellipsis ${threadMessageStyle}`}
                                    style={{
                                        maxWidth: "180px",
                                        maxHeight: "20px",
                                    }}
                                >
                                    {convertHtmlStringToText(props.message.message)}
                                </div>
                                {
                                    <div
                                        style={{
                                            maxWidth: "120px",
                                            minWidth: "80px",
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            gap: "8px",
                                        }}
                                    >
                                        {props?.message?.hasAttachments ? (
                                            <SlantedPaperClipIcon color={IconColor} />
                                        ) : null}
                                        {props?.message?.folderId == FolderType.SENT &&
                                            props?.message?.deliveryType == DeliveryType.Forward && (
                                                <ForwardIcon color={IconColor} />
                                            )}
                                        {props?.message?.folderId !== FolderType.SENT && (
                                            <span className="message-type-label received-tag">Received</span>
                                        )}
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {props.message?.threadMessages && props.message?.threadMessages?.length > 0 && isExpanded && (
                <div className="thread-message-div">
                    {props.message?.threadMessages?.map((thread, index) => {
                        const isChecked =
                            props.selectedSentMessage.messages.includes(thread) ||
                            props.selectedSentMessage.isAllSelected;
                        return (
                            <SentMessageListItem
                                key={thread.sentMessageId}
                                message={thread}
                                selectedMessageId={props.selectedMessageId}
                                index={index}
                                isChecked={isChecked}
                                onSelected={props.onSelected}
                                onClick={props.onClick}
                                isThreadMessage={true}
                                selectedSentMessage={props.selectedSentMessage}
                                collapseAllThreads={props.collapseAllThreads}
                                selectedMessageOriginFolder={props.selectedMessageOriginFolder}
                            />
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default SentMessageListItem;
